export default __webpack_public_path__ + "static/moving-in-and-up-255efe3e3413aba2c832b66f4a0a2cc5.jpg";